import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import Menu from "./Menu";
import Booking from "./Booking";
import Slider from "./Slider";
import Dataentry from "./Dataentry";
import SiteFooter from "./SiteFooter";
import axios from 'axios';
import { apiUrl } from "../apiConfig";
import Live from './Live';
import Popup from './Popup';
import Rightside from './Rightside';
import Rolling from './Rolling';
import IconGrid from "./IconGrid";
import StaticLatestUpdate from "./StaticLatestUpdate"
import DietyList from './DietyList';
import DressCode from './DressCode';
import DonationSection from './DonationSection';
import Bar from "./Bar";
import DressCodePopup from './DressCodePopup';
import Sdarsan from './Sdarsan';
import Video from './Video';

// const API_BASE = "http://localhost/myapp/api/uploads";

const API_BASE = apiUrl();

function Home() {

	return (
		<div>
			<div style={{}}>
				<Video />
				
			</div>

			{/* <Live /> */}
			{/* <Popup /> */}
			{/* <div className="row slider" style={{backgroundImage:'url(./images/spst-pl.jpg)',backgroundSize:'cover',backgroundPosition:'center',display:'flex',alignItems:'end',justifyContent:'center'}}>
		
		<div style={{width:'800px'}}>
			<img src="./images/spst-home-icon.png" alt="logo" className="homeimage" style={{width:'100%'}} />
		</div>
	</div> */}

			{/* Video Slider
	<div className="video-container">
      <video
        className="background-video"
        autoPlay
        loop
        muted
        playsInline
		style={{width:'100%',height:'100%'}}
      >
        <source src="./images/spst.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
</div> */}



			{/* <Popup /> */}
			{/* <Live /> */}
			{/* <!-- Sections --> */}
			{/* <Popup /> */}
			{/* <Slider /> */}
			{/* <img src="./images/pic-1.jpeg" alt="image" style={{width:'100%'} }/> */}
			<Rolling />

			{/* <div style={{width:'100%'}}>
			<img src="./images/pic-3.jpeg" style={{width:'100%'}} /> <br />
			<img src="./images/pic-6.jpeg" style={{width:'100%'}} />
		</div> */}

			{/* <div style={{width:'auto',marginLeft:'auto',marginRight:'auto',borderBottom:'1px solid maroon',padding:'20px'}}>
						<p className="cloak" style={{textAlign:'center',fontSize:'12pt',fontWeight:'700',color:'black'}}>Temple Cloak Room Timings | Morning: 03:30 am to 02:00 pm & Evening: 03:30 pm to 09:00 pm</p>
					</div> */}
			<div className="container">
				<div className="row">
					<div className="col-md-12">
						<Bar />
					</div>
				</div>
			</div>
			<div className="container">
				<div className="col-md-12">
				<Sdarsan />
			</div>
			</div>
			
			<div className="container" style={{ marginTop: '90px', marginBottom: '90px', marginLeft: 'auto', marginRight: 'auto' }}>
				<div className="row">
					<div className="col-md-12">
						<Booking />
					</div>
						
					<div className="col-md-12" >

						<DietyList />
					</div>
					<img src="./images/spst-1.jpg" alt="logo" className="homeimage" style={{ width: '100%',borderRadius: '20px' }} />

				</div>

			</div>
			<div className="row" style={{ backgroundImage: 'url(./images/spst-l1.jpeg)', backgroundSize: 'cover', backgroundAttachment: 'fixed' }}>
				<div className="container" style={{ background: 'rgba(255, 255, 255, 0.8)', padding: '15px' }}>
					<div className="row">
						<div className="col-md-12" style={{ borderRadius: '10px' }}>
							<Rightside />
						</div>
						<div className="col-md-4" style={{}}>

						</div>
					</div>
					{/* <div className="col-md-4">
					<StaticLatestUpdate />
				</div> */}
				</div>
			</div>

			{/* <DonationSection /> */}
			<div className="container">
				<div className="row">
					<div className="col-md-8">
						<IconGrid />
					</div>
					<div className="col-md-4" style={{ display: 'flexx', alignItems: 'center', justifyContent: 'center', padding: '50px' }}>
						<DressCodePopup />
					</div>
				</div>
			</div>



			{/* <div style={{ backgroundImage: 'url(./images/spst.webp)', backgroundSize: 'cover', backgroundAttachment: 'fixed', backgroundPosition: 'center' }}>
				<DressCode />
			</div> */}





			{/* <div class="container" style={{ paddingTop: '75px', paddingBottom: '75px' }}>
				<div class="row">
					<div class="col-md-5">
						<div className="fund">
							<img src="./images/suvarnadarsan.png" alt="Suvarna Darsanam" style={{ width: '100%', borderRadius: '15px' }} />
							<center><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=75" className="btn btn-primary" style={{width:'150px',background:'orange',color:'maroon',border:'none',fontSize:'14pt',fontWeight:'700',marginTop:'15px'}}>Book </Link></center>
						</div>
					</div>
					<div class="col-md-7">
						<div className="fund">
							<img src="./images/bhadratha.png" alt="Suvarna Darsanam" style={{ width: '100%', borderRadius: '15px' }} />
							<center><Link to="https://booking.sreepadmanabhaswamytemple.org/OtherOfferings.aspx?Pid=1&Vid=72" className="btn btn-primary" style={{ width: '150px', background: 'orange', color: 'maroon', border: 'none', fontSize: '14pt', fontWeight: '700', marginTop: '15px' }}>Book </Link></center>
						</div>
					</div>
				</div>
			</div> */}
			{/* <div className="gosala">
				<div className="overlay">
					<div class="gosaladonate">
						<Link to="https://booking.sreepadmanabhaswamytemple.org/Murajepam.aspx" className="btn btn-primary" style={{ padding: '20px', background: 'orange', color: 'maroon', fontSize: '14pt', fontWeight: '400', border: '1px solid orange' }}>Goshala Donation</Link>
						<Link to="https://booking.sreepadmanabhaswamytemple.org/GoldenGrace.aspx" className="btn btn-primary" style={{ padding: '20px', background: 'orange', color: 'maroon', fontSize: '14pt', fontWeight: '400', border: '1px solid orange' }}>Donate Golden Grace & Grandeur</Link>
					</div>


				</div>

			</div> */}
			<div className="container" style={{ marginTop: '100px' }}>
				<div className="row" style={{ background: 'maroon_', backgroundAttachment: 'fixed', padding: '20px', paddingTop: '50px' }}>
					<div className="col-md-12">

						{/* <div style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%'}}><img src="./images/popup.jpeg" alt="SPST " style={{ width: '100%' }} /></div> */}
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}><img src="./images/eve_1.jpeg" alt="SPST " style={{ width: '100%', borderRadius: '30px' }} /></div>
						{/* <div style={{display:'flex',alignItems:'center',justifyContent:'center',width:'100%'}}><img src="./images/eve_2.jpeg" alt="SPST " style={{ width: '100%' }} /></div> */}

						{/* <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}><img src="./images/eve_5.jpeg" alt="SPST " style={{ width: '100%' }} /></div> */}
					</div>
					<div className="col-md-6">
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', padding: '50px' }}><img src="./images/eve_3.jpeg" alt="SPST " style={{ width: '100%' }} /></div>
					</div>
					{/* <div className="col-md-4">
						<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}><img src="./images/lelam.jpeg" alt="SPST " style={{ width: '100%' }} /></div>
					</div> */}

					<div className="container">

					</div>


				</div>
			</div>



		</div>

	);
}

export default Home;
